export const formatDuration: (duration: any, t: any) => string = (duration, t) => {
  if (!Number.isNaN(parseInt(duration))) {
    const hours = Math.floor(parseInt(duration) / 60);
    const minutes = parseInt(duration) % 60;
    const formattedHours =
      hours > 0
        ? hours === 1
          ? `${hours} ${t('pages_search_cardSingularHour')}`
          : `${hours} ${t('pages_search_cardHours')}`
        : '';
    const formattedMinutes =
      minutes > 0
        ? minutes === 1
          ? `${minutes} ${t('pages_search_cardSingularMinute')}`
          : `${minutes} ${t('pages_search_cardMinutes')}`
        : '';
    return formattedHours + ' ' + formattedMinutes;
  }
  return '';
};
